var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42175 1.16675H10.7551C11.448 1.16675 12.0191 1.73791 12.0191 2.4308V3.81654C12.0191 4.32216 11.7008 4.94951 11.3918 5.26786L8.67647 7.66486C8.30193 7.98321 8.04909 8.61054 8.04909 9.11615V11.8315C8.04909 12.2061 7.79629 12.7117 7.47794 12.9083L6.59779 13.4794C5.77382 13.9851 4.64084 13.4139 4.64084 12.4027V9.05998C4.64084 8.6199 4.38805 8.04876 4.13525 7.73041L1.73825 5.20232C1.4199 4.88396 1.16711 4.32216 1.16711 3.93827V2.48697C1.15774 1.73791 1.72887 1.16675 2.42175 1.16675Z",
    stroke: "#149CCE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f71cd26f1e91601b471dc058363fb9f8.svg";
export { ForwardRef as ReactComponent };